import React from 'react';
import styles from './ResetAllWarningDialog.module.css';
import Dialog, { Banner as DialogBanner } from 'system/base/Dialog';
import { DangerButton, NakedButton } from 'system/base/Button';

export interface ResetAllWarningDialogProps {
  isOpen: boolean;
  onConfirm: () => void;
  onDismiss: () => void;
}

export function ResetAllWarningDialog({
  isOpen,
  onConfirm,
  onDismiss,
}: ResetAllWarningDialogProps) {
  return (
    <Dialog
      isOpen={isOpen}
      onDismiss={onDismiss}
      title="Reset template and delete all data?"
    >
      <DialogBanner type="error">
        <div>
          <div>
            All items in the template will be deleted
            <br />
            All extracted data will be deleted
          </div>
        </div>
      </DialogBanner>

      <p>
        Are you sure you want to reset the template and delete all extracted
        data from studies?
      </p>
      <p>
        <strong>This action cannot be undone.</strong>
      </p>

      <div className={styles.modalFooter}>
        <DangerButton mr={2} onClick={onConfirm}>
          Yes, delete
        </DangerButton>
        <NakedButton onClick={onDismiss}>Cancel</NakedButton>
      </div>
    </Dialog>
  );
}
